<template>
    <div>
        <img src="../src/assets/projects/skincare.png" style="width: 100%; " />
    </div>
    <div  class="big-title1 mr-100 tit">
        <span class="big-title-art1">S</span>kincare
    </div>
    <section class="products-section">
        <Product :products="products"></Product>
    </section>

    <div style="display: flex; justify-content: center;  " class=" mr-100">
        <el-pagination background layout="prev, pager, next" :total="10" />
    </div>
</template>

<script>
    import Product from '../src/components/Product.vue'

    export default {
        name: 'Shop',
        data() {
            return {
                products: [],

            }
        },
        components: {
            Product
        },
        mounted() {

            this.loadData();
        },
        methods: {
            async loadData() {
                try {
                    const response = await fetch('/products.json'); // 注意路径应为相对于public文件夹的路径，或者使用绝对路径如`/data/file.json`
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();

                    this.products = data.filter(d => d.series =='Soins Cutanés');

                    for (var i = 0; i < this.products.length; i++) {
                        let num = this.products[i].image;
                        const image = require(`@/assets/projects/${num}.jpg`);
                        this.products[i].image = image;
                    }
                } catch (error) {
                    console.error('There has been a problem with your fetch operation:', error);
                }
            },
        }
    }
</script>

<style scoped>
   
    .quick-view {
        background: #fff;
        color: #e83e8c;
        border: none;
        padding: 10px 20px;
        border-radius: 20px;
        cursor: pointer;
        font-weight: 500;
    }

    .product-info {
        padding: 20px;
    }

    .product-name {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 30px;
        color: #333;
    }

    .product-price {
        position: relative;
        margin-bottom: 20px;
    }

    .price {
        font-size: 20px;
        font-weight: bold;
        color: #5c5c5c;
    }

    .add-to-cart {
        background-color: #f8f8f8;
        border: none;
        width: 40px;
        height: 40px;
        borderRadius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s;
        position: absolute;
        right: 10px;
        bottom: 0px;
    }

        .add-to-cart:hover {
            background-color: #e83e8c;
            color: white;
        }
</style>